import React from 'react'
import { Edit } from 'react-admin'
import WithDeleteModalToolbar from 'ui-shared/CustomToolbars/WithDeleteModalToolbar'
import UpsellingFacetSection from 'ui-shared/Facets/FacetFormSections/UpsellingFacetSection'
import UpsellingForm from 'ui-shared/Forms/UpsellingForm'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'

const PhysicalExperienceUpsellingEdit: React.FC = () => {
  return (
    <SectionWrapper>
      <Edit>
        <UpsellingForm
          relatedProduct="physicals"
          facetFields={<UpsellingFacetSection />}
          toolbar={<WithDeleteModalToolbar />}
        />
      </Edit>
    </SectionWrapper>
  )
}

export default PhysicalExperienceUpsellingEdit
